/**
 * V70 타자왕 — 결정론적 PRNG (Mulberry32)
 *
 * Phase 2: 클라이언트에서 단어 큐 생성 재현
 * Phase 3: 동일 알고리즘을 BE 에서 사용해 commitment hash 검증
 *
 * 외부 라이브러리 의존 없이 자체 구현 (seedrandom 등 추가 안 함).
 * Mulberry32: 32-bit state, 매 호출 상태 업데이트 → 결정론적 재현 보장.
 */

/**
 * seed string (session id 등) → 32-bit integer
 */
export function hashSeed(seed: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/**
 * Mulberry32 PRNG 생성 (0 <= x < 1)
 * Phase 3 BE 와 동일한 알고리즘 사용
 */
export function createPrng(seed: number): () => number {
  let state = seed >>> 0;
  return function () {
    state = (state + 0x6D2B79F5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * PRNG 로 배열에서 index 선택
 */
export function pickIndex<T>(rand: () => number, arr: readonly T[]): number {
  return Math.floor(rand() * arr.length);
}

/**
 * PRNG 로 배열에서 요소 하나 선택
 */
export function pickOne<T>(rand: () => number, arr: readonly T[]): T {
  return arr[pickIndex(rand, arr)];
}
